import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { alpha } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import Iconify from '../../theme/iconify/iconify';
import { useTranslation } from "react-i18next";
import HomeHeader from "./HomeHeader";

function PageNotFound({ user, updateUser }) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <>
            <HomeHeader user={user} updateUser={updateUser} bgColor={'#F9FAFB'} />

            <Container>
                <Box
                    sx={{
                        py: 12,
                        maxWidth: 480,
                        mx: 'auto',
                        display: 'flex',
                        minHeight: '90vh',
                        textAlign: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}
                >
                    <Typography variant='h3' sx={{ mb: 3 }}>
                        {t('404.title')}
                    </Typography>

                    <Typography sx={{ color: 'text.secondary' }}>
                        {t('404.description')}
                    </Typography>

                    <Box
                        component='img'
                        src='/assets/images/DR-mISLec-404.png'
                        sx={{
                            mx: 'auto',
                            height: 'auto',
                            my: { xs: 5, sm: 10 },
                        }}
                    />

                    <Button
                        variant=''
                        startIcon={<Iconify icon='ant-design:home-outlined' />}
                        onClick={() => navigate('/')}
                        sx={{
                            borderRadius: '8px !important',
                            backgroundColor: 'rgba(33, 43, 54, 0.08)',
                            '&:hover': {
                                backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
                                color: 'primary.main'
                            }
                        }}
                    >
                        {t('404.button')}
                    </Button>
                </Box>
            </Container>
        </>
    );
}

export default PageNotFound;